import { Grid } from '@material-ui/core'
import React from 'react'
import { Link } from 'react-router-dom'
import { useTranslations } from '../../../shared/context/translations'
import { colors } from '../../../shared/ui/colors'
import { Gap } from '../../../shared/ui/gap'
import { SmallP } from '../../../shared/ui/headings'
import { SectionRenderer } from '../../../shared/ui/section-renderer'
import { Stack } from '../../../shared/ui/stack'
import parseMarkdown from '../../../shared/utils/markdown'
import NewsCard from '../news/news-card'
import { Description, Root, Separator, Title } from './styled'
import { useSetScrollToZero } from '../../../../vicoustic/utility/use-set-scroll-to-zero'

const NewsDetail = props => {
  const {
    related,
    title,
    sections,
    description,
    // mainImage,
    date,
  } = props
  const t = useTranslations('news')
  useSetScrollToZero(0)

  return (
    <Root>
      <Gap x={2} />
      <SmallP
        style={{
          textAlign: 'center',
          color: colors.midGray,
        }}
      >
        {date} <Separator /> <Link to="/news">{t('backButton.text')}</Link>
      </SmallP>
      <Stack>
        <Title as="h1"><b>{title}</b></Title>
        <Description><b>{description}</b></Description>
        {sections.map(section => <SectionRenderer {...section} />)}
      </Stack>
      {related && related.length !== 0 && (
        <>
          <Gap x={2} />
          <Title dangerouslySetInnerHTML={{ __html: parseMarkdown(t('related')) }} />
          <Gap x={2} />
          <Grid container spacing={2} alignItems='stretch' justifyContent='center'>
            {related.map(article => (
              <Grid item container md={4} sm={6} key={article.id}>
                <NewsCard {...article} />
              </Grid>
            ))}
          </Grid>
        </>
      )}
      <Gap />
    </Root>
  )
}

export default NewsDetail
